// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__72TYB","loader":"Loader_loader__DyBpl","spinner":"Loader_spinner__EYHjj"};